import { getCurrentLang } from '@umu/ukit-lang';

export const LANG  = getCurrentLang().toUpperCase() as "CN" | "EN" | "ES" | "TH" | "JP" | "TW" | "KO" | "FR" | "ID" | "RU" | "PT" | "DE" | "IT" | "VI" | undefined;
